module.exports = __webpack_public_path__ + "static/media/img-news2.72be47af.jpg";